import React from 'react';
import { TARGET_BLANK } from '../constants/windowTarget';

interface LinkWrapperProps {
  url?: string;
  target?: string;
  shouldWrap?: boolean;
  onClick?: () => void;
  isTeamSquad?: boolean;
}

export const LinkWrapper: React.FC<React.PropsWithChildren<LinkWrapperProps>> = ({
  url = '#',
  target = TARGET_BLANK,
  children,
  shouldWrap = true,
  onClick,
  isTeamSquad,
}) => {
  const childrenResult = shouldWrap ? <div style={{ pointerEvents: isTeamSquad ? 'auto' : 'none' }}>{children}</div> : <>{children}</>;

  if (shouldWrap) {
    return (
      <a href={url} target={target} style={{ display: 'block', textDecoration: 'none', color: 'inherit' }} onClick={onClick}>
        {childrenResult}
      </a>
    );
  }

  return childrenResult;
};
